import { VExpansionPanel } from 'vuetify/lib'

export default {
    extends: VExpansionPanel,

    props: {
        collapsible: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        toggle() {
            return this.collapsible && VExpansionPanel.options.methods.toggle.call(this);
        }
    }
}
